<template>
  <div>
    <core-grid ref="grid"
               :onRead="onRead"
               :schema="schema"
               :add-option="false"
               :edit-option="false"
               :delete-option="false"
               >
    </core-grid>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      schema: [
        { value: 'nome', text: 'Nome' },
        { value: 'email', text: 'E-mail' }
      ]
    }
  },
  methods: {
    onRead: function (options, search) {
      const dto = { parameters: [{ name: 'search', value: search }] }
      this.$api.Usuario.GetAll(dto).then(function (response) {
        options.success(response)
      })
    },
    refresh () {
      this.$refs.grid.refresh()
    },
    response (data) {
      if (data) { this.refresh() }
    }
  }
}
</script>
